import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full h-full overflow-y-auto max-w-14xl flex flex-col items-center text-gray-600 text-sm mx-auto my-0" }
const _hoisted_2 = { class: "self-start my-2 mr-0 ml-4 text-base text-gray-200" }
const _hoisted_3 = {
  ref: "scroll",
  class: "bg-gray-100 overflow-auto flex flex-1 flex-col self-stretch"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_rating_head_bar = _resolveComponent("rating-head-bar")!
  const _component_card_lecture = _resolveComponent("card-lecture")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_rating_head_bar, {
      "is-back-visible": "",
      onClickBack: _cache[0] || (_cache[0] = ($event: any) => (_ctx.routerBack('/rating')))
    }),
    _createElementVNode("div", _hoisted_2, " “" + _toDisplayString(_ctx.parsedQ) + "”的搜索结果 ", 1),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchResults, (searchResult) => {
        return (_openBlock(), _createBlock(_component_card_lecture, {
          key: searchResult.id,
          class: "mt-1.5 mx-0 mb-1 f-clickable",
          lecture: searchResult,
          onClick: ($event: any) => (_ctx.$router.push(`/rating/lecture/${searchResult.id}`))
        }, null, 8, ["lecture", "onClick"]))
      }), 128))
    ], 512)
  ]))
}